// extracted by mini-css-extract-plugin
module.exports = {"half":"Hero-module--half--3BCvq","hero":"Hero-module--hero--IsIdy","light":"Hero-module--light--1jDPD","content":"Hero-module--content--1gl6U"};